import { connect } from 'react-redux'
import { required } from 'util/validation'
import withFormFields from 'shared/ui/Form/withFormFields'
import { doSaveAndRedirect } from './actions'

import CompanyPageView from './view'

const validators = {
  name: required,
  currentSupportSolution: required,
  numberOfEmployees: required,
  industry: required,
}

const initialValues = {
  name: '',
  currentSupportSolution: null,
  currentSupportSolutionSelect: null,
  currentSupportSolutionText: '',
  numberOfEmployees: null,
  industry: null,
}

const select = () => ({
  initialValues,
  validators,
})

const perform = {
  onSave: doSaveAndRedirect,
}

export default connect(select, perform)(withFormFields(CompanyPageView))
